// ═══ 차종 한글→영문 매핑 — server-side utils/helpers.js CAR_NAME_EN 와 동기화 ═══
// Invoice.js / InvoiceDetail.js / CarList.js / contractPrint.js 등 영문 출력용.
// drift 방지: 사전 변경 시 server-side 와 동시 갱신 필수.
// 회귀 가드: tests/car-name-en-client-sync.test.js
//
// (carNameEn.js 는 동일 사전 별도 사본 — 통합은 향후 백로그)

var CAR_NAME_EN = {
  '프라이드':'PRIDE','포르테':'FORTE','아반떼':'AVANTE','로체':'LOTZE','쏘렌토':'SORENTO',
  '투싼':'TUCSON','싼타페':'SANTA FE','그랜저':'GRANDEUR','쏘나타':'SONATA','모닝':'MORNING',
  '레이':'RAY','스포티지':'SPORTAGE','셀토스':'SELTOS','카니발':'CARNIVAL','스타리아':'STARIA',
  '베르나':'VERNA','K3':'K3','K5':'K5','K7':'K7','K8':'K8','K9':'K9',
  '팰리세이드':'PALISADE','코나':'KONA','아이오닉5':'IONIQ5','아이오닉6':'IONIQ6','아이오닉':'IONIQ',
  '니로':'NIRO','쏘울':'SOUL','스팅어':'STINGER','제네시스':'GENESIS','봉고':'BONGO',
  '포터':'PORTER','스타렉스':'STAREX','그랜드스타렉스':'GRAND STAREX','마이티':'MIGHTY','액센트':'ACCENT',
  '에쿠스':'EQUUS','베뉴':'VENUE','맥스크루즈':'MAXCRUZ','리오':'RIO','옵티마':'OPTIMA',
  '올란도':'ORLANDO','스파크':'SPARK','말리부':'MALIBU','캐스퍼':'CASPER','베라크루즈':'VERACRUZ',
  '포르테쿱':'FORTE KOUP','엑센트':'ACCENT','벨로스터':'VELOSTER','제네시스쿠페':'GENESIS COUPE',
  '리베로':'LIBERO','갤로퍼':'GALLOPER','테라칸':'TERRACAN','모하비':'MOHAVE','쏘렌토R':'SORENTO R',
  '오피러스':'OPIRUS','SM5':'SM5','SM6':'SM6','SM7':'SM7','QM5':'QM5','QM6':'QM6',
  'XM3':'XM3','마스터':'MASTER','티볼리':'TIVOLI','코란도':'KORANDO','렉스턴':'REXTON',
  '무쏘':'MUSSO','체어맨':'CHAIRMAN','액티언':'ACTYON','크루즈':'CRUZE','트랙스':'TRAX',
  '이쿼녹스':'EQUINOX','카마로':'CAMARO','EV6':'EV6','i30':'i30','i40':'i40','ix35':'ix35'
};

// 한글 차종명에서 영문 매칭 (부분 매칭). 매칭 실패 시 원본 반환.
function getEngCarName(name) {
  if (!name) return '';
  var keys = Object.keys(CAR_NAME_EN);
  for (var i = 0; i < keys.length; i++) {
    if (name.indexOf(keys[i]) !== -1) return CAR_NAME_EN[keys[i]];
  }
  return name;
}

export { CAR_NAME_EN, getEngCarName };
